import { render, staticRenderFns } from "./panel-full-height-side.vue?vue&type=template&id=093b2a2e"
import script from "./panel-full-height-side.vue?vue&type=script&lang=js"
export * from "./panel-full-height-side.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports